import {
  HISTORICAL_REFRESH,
  HISTORICAL_SELECT,
  HISTORICAL_LOAD,
  HISTORICAL_MODIFY,
  HISTORICAL_UNSET,
  HISTORICAL_REFRESH_REQUESTING,
  HISTORICAL_VISIBLE,
  HISTORICAL_LOAD_REQUESTING,
  HISTORICAL_ERROR,
  SELECT_FEEDBACK,
} from "./constants";
import moment from "moment-timezone";
import i18n from "../../i18n";
import { IHistoricalReducer } from "./types";

const initialState: IHistoricalReducer = {
  loading: false,
  data: [
    {
      _id: "",
      count: 0,
      action: {},
      title: i18n.t("no-historical"),
      category: "leadership",
      noHistorical: true,
      date: moment().toDate(),
    },
  ],
  historicalSelected: {
    action: {},
  },
  feedbackSelected: "",
  historicalIndex: 0,
  error: "",
  lastRefresh: moment().subtract(1, "day").toDate(),
  refreshing: false,
  offline: false,
  visibleId: 0,
};

const reducer = function userReducer(
  state: IHistoricalReducer = initialState,
  action,
): IHistoricalReducer {
  switch (action.type) {
    case SELECT_FEEDBACK:
      return {
        ...state,
        feedbackSelected: action.payload,
      };

    case HISTORICAL_LOAD:
      return {
        ...initialState,
        offline: false,
        loading: false,
        lastRefresh: moment().toDate(),
        // historicalIndex: action.payload.historicalIndex,
        // data: state.data.concat(action.payload.historical)
        data: action.payload,
      };

    case HISTORICAL_LOAD_REQUESTING:
      return {
        ...state,
        loading: true,
      };

    case HISTORICAL_SELECT:
      return {
        ...state,
        historicalSelected: action.payload,
      };

    case HISTORICAL_REFRESH_REQUESTING:
      return {
        ...state,
        refreshing: true,
      };

    case HISTORICAL_ERROR:
      return {
        ...state,
        refreshing: false,
        loading: false,
      };

    case HISTORICAL_REFRESH:
      // if (action.payload.historical.length <= 0) {
      //   return initialState;
      // }
      return {
        ...state,
        refreshing: false,
        offline: false,
        lastRefresh: moment().toDate(),
        // historicalIndex: action.payload.historicalIndex,
        // data: action.payload.historical
        data: action.payload,
      };

    case HISTORICAL_VISIBLE:
      return {
        ...state,
        visibleId: action.payload,
      };

    case HISTORICAL_MODIFY: {
      const data = action.payload;
      return {
        ...state,
        data,
      };
    }
    /*
    case HISTORICAL_ADD_LOVE: {
      const foundIndex = state.data.findIndex(el => el._id === action.payload);
      const newData = state.data.map((item, index) => {
        if (index !== foundIndex) {
          return item;
        }
        return {
          ...item,
          loveCount: item.loveCount + 1,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
*/
    // used ?
    case HISTORICAL_UNSET:
      return initialState;

    // case offlineActionTypes.FETCH_OFFLINE_MODE:
    //   if (action.payload.prevAction.type === HISTORICAL_REFRESH_REQUESTING) {
    //     return {
    //       ...state,
    //       offline: true
    //     };
    //   }
    // return state;

    default:
      return state;
  }
};

export default reducer;
